import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
  Box,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTheme } from "@emotion/react";
import { useSelector } from "react-redux";
import { getAllData } from "../../Utility/API";
import { endPoints, PaymentEndpoints } from "../../constant/Environment";

const BalanceConvertModal = ({ open, onClose, balance, currency }) => {
  const theme = useTheme();
  const authState = useSelector((state) => state.auth);
  const { IsLoginData } = authState;
  const [rates, setRates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currencyList, setCurrencyList] = useState([]);

  useEffect(() => {
    if (!open || currencyList.length > 0) return;
    
    const getCurrencyList = async () => {
      try {
        if (IsLoginData?.idUser) {
          let url = `${endPoints.api.GET_CURRENCY_LIST_USER}/${IsLoginData?.idUser}`;
          const response = await getAllData(url);
          if (response?.status === "success") {
            setCurrencyList(response?.data || []);
          }
        }
      } catch (error) {
        console.error("Error fetching currency list:", error);
      }
    };

    getCurrencyList();
  }, [open, IsLoginData?.idUser]);

  useEffect(() => {
    if (!open || !balance || !currency || currencyList.length === 0) return;

    const fetchRates = async () => {
      setLoading(true);
      setRates([]);
      const newRates = [];
      
      for (const crypto of currencyList) {
        try {
          const url = `${PaymentEndpoints.apiBaseUrl}${PaymentEndpoints.api.CURRENCY_CONVERT}?from=${currency}&to=${crypto.value}&amount=${balance}`;
          const res = await fetch(url);
          const data = await res.json();
          newRates.push({ ...crypto, converted: data?.data?.convertedAmount ?? null });
        } catch {
          newRates.push({ ...crypto, converted: null });
        }
        await new Promise((resolve) => setTimeout(resolve, 150));
      }
      
      setRates(newRates);
      setLoading(false);
    };

    fetchRates();
  }, [open, balance, currency, currencyList]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      BackdropProps={{
        style: {
          backdropFilter: "blur(5px)",
          backgroundColor: "rgba(0,0,0,0.4)",
        },
      }}
      PaperProps={{
        style: {
          background: theme.palette.background.paper,
          borderRadius: 12,
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          pb: 1,
        }}
      >
        <Typography variant="h6" sx={{ color: theme.palette.text.primary }}>
          Balance in Crypto
        </Typography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon sx={{ color: theme.palette.text.primary }} />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        {/* <Typography
          variant="body2"
          sx={{ color: theme.palette.text.secondary, mb: 2 }}
        >
          Your balance of{" "}
          <strong>
            {parseInt(balance)} {currency}
          </strong>{" "}
          in crypto:
        </Typography> */}

        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
            <CircularProgress size={32} />
          </Box>
        ) : (
          rates.map((crypto) => (
            <Box
              key={crypto.value}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                py: 1.2,
                borderBottom: `1px solid ${theme.palette.divider}`,
                "&:last-child": { borderBottom: "none" },
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                <img
                  src={crypto.iconPng || crypto.icon}
                  alt={crypto.symbol}
                  style={{ width: 28, height: 28 }}
                />
                <Typography sx={{ color: theme.palette.text.primary }}>
                  {crypto.name}
                </Typography>
              </Box>
              <Typography
                sx={{ color: theme.palette.custom?.green1 ?? "#4caf50", fontWeight: 600 }}
              >
                {crypto.converted !== null
                  ? `${parseFloat(crypto.converted).toFixed(6)} ${crypto.symbol}`
                  : "—"}
              </Typography>
            </Box>
          ))
        )}
      </DialogContent>
    </Dialog>
  );
};

export default BalanceConvertModal;
